import { useState } from "react";

const TEXT = `THIS IS A WORK OF PARODY AND SATIRE. This website is NOT affiliated with, endorsed by, sponsored by, or connected to Donald J. Trump, the Trump Organization, any political committee, campaign, PAC, or political party. No portion of any payment is an actual political donation, will be forwarded to any political figure, candidate, party, or political committee, and is not tax-deductible as a charitable contribution. All "bonuses," "matches," "VIP tiers," "platinum patriot rewards," and similar claims are jokes used solely for comedic effect. Any resemblance of real persons, fake testimonials, fake donor names, fake locations, fake counters, or fake urgency to actual events, persons, or merchandise is entirely intentional and entirely fictional. By proceeding to checkout you acknowledge that you understand this is a comedy demonstration project, that you are voluntarily testing a payment integration, and that you waive all rights to be surprised by anything. Eagles featured in this site were not consulted. Do not feed the eagles.`;

export default function Disclaimer() {
  const [size, setSize] = useState(10);
  const sizes = [10, 12, 14, 16, 20];

  return (
    <footer
      data-testid="footer-disclaimer"
      className="relative px-6 py-10 bg-black text-[#9aa3b2] border-t border-[#ffd700]/30"
    >
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
          <span className="font-accent text-[10px] tracking-[0.3em] text-[#ffd700]">
            Legal · Parody · Fine Print
          </span>
          <div className="flex items-center gap-2">
            <span className="text-[10px] uppercase tracking-widest opacity-60">
              Text Size
            </span>
            {sizes.map((s) => (
              <button
                key={s}
                data-testid={`disclaimer-size-${s}`}
                onClick={() => setSize(s)}
                className={
                  "px-2 py-1 text-[10px] uppercase border transition-all " +
                  (size === s
                    ? "border-[#ffd700] text-[#ffd700] bg-[#ffd700]/10"
                    : "border-white/20 text-white/50 hover:border-white/50")
                }
              >
                {s}px
              </button>
            ))}
          </div>
        </div>
        <p
          data-testid="disclaimer-text"
          style={{ fontSize: `${size}px`, lineHeight: 1.5 }}
          className="opacity-80"
        >
          {TEXT}
        </p>
        <p
          className="mt-4 tracking-widest uppercase opacity-50"
          style={{ fontSize: `${Math.max(9, size - 2)}px` }}
        >
          © {new Date().getFullYear()} Patriot Bonus Drive (Parody Demo). All eagles reserved.
          <span className="ml-3 opacity-60">·</span>
          <a href="/wall" data-testid="wall-link" className="ml-3 hover:text-[#ffd700] transition-colors">Wall of Fame</a>
          <span className="ml-3 opacity-60">·</span>
          <a href="/admin" data-testid="admin-link" className="ml-3 hover:text-[#ffd700] transition-colors">Admin</a>
        </p>
      </div>
    </footer>
  );
}
